import { type Product } from 'schema-dts'

import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

import { getVariantSchema } from './getVariantSchema'

export const getSimilarToSchema = (
  product: PimProductWithVariantsV1,
  isMarketplace: boolean,
  fallback: string,
): Product[] | undefined => {
  const variants = product.variants.filter(
    (variant) => variant.upid !== product.upid,
  )

  return variants.length > 0
    ? variants.map((variant) =>
        getVariantSchema(variant, isMarketplace, fallback),
      )
    : undefined
}
